import type { FiltersRepository } from '../../domain/interfaces/FiltersRepository';
import type { PlpFiltersResult } from '../../domain/models/Filter';
import type { PlpApiContextParams } from '@/features/plp/domain/interfaces/PlpRepository';
import type { PlpPageType } from '@/features/plp/constants';

export type FiltersService = ReturnType<typeof createFiltersService>;

export interface GetFiltersParams extends Omit<PlpApiContextParams, 'page_type'> {
  page_type: PlpPageType;
  tags: string;
}

export function createFiltersService(repo: FiltersRepository) {
  return {
    async getFilters(params: GetFiltersParams): Promise<PlpFiltersResult> {
      return repo.fetchFilters(params);
    },
  };
}
